<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-12">
          <card shadow>
            <div slot="header" class="bg-transparent border-0">
              <div class="row align-items-center">
                <div class="col-1">
                  <base-button type="primary" size="sm" @click="$router.back()"
                    ><i class="ni ni-bold-left"></i
                  ></base-button>
                </div>
                <div class="col-8">
                  <h3 class="mb-0">{{ $t("show_products") }}</h3>
                </div>
              </div>
            </div>
            <template>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="mb-3 col-md-7">
                    <image-zoom
                      :regular="imageData(destImage)"
                      :zoom="imageData(destImage)"
                      :zoom-amount="3"
                      :click-zoom="true"
                      img-class="img-fluid"
                      alt="Grass"
                      style="min-width: 80%; max-width: 300px"
                    >
                    </image-zoom>
                  </div>
                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <h3>{{ $t("sku") }}</h3>
                        <span>{{ getProduct.sku }}</span>
                      </div>
                      <div class="col-md-6 mb-3">
                        <h3>{{ $t("name") }}</h3>
                        <span>{{ getProduct.name }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <h3>{{ $t("price") }}</h3>
                        <span
                          >{{ getProduct.currency ? getProduct.currency.symbol : '' }}
                          {{ getProduct.price }}</span
                        >
                      </div>
                      <div class="col-md-6 mb-3">
                        <h3>{{ $t("description") }}</h3>
                        <span>{{ getProduct.description }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <h3>{{ $t("category") }}</h3>
                        <span
                          class="badge badge-primary mt-2"
                          v-for="(vm, i) in getProduct.categories"
                          :key="i"
                          >{{ vm.name }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <carousel
                      :perPage="10"
                      :centerMode="true"
                      :loop="true"
                      :autoplay="true"
                    >
                      <slide v-for="(vm, i) in getImages" :key="i">
                        <b-img
                        class="p-1"
                          @click="changeImage(vm)"
                          fluid
                          :src="imageData(vm.image)"
                          alt="Image 1"
                        ></b-img>
                        <button
                          v-b-tooltip.hover
                          :title="$t('delete')"
                          type="button"
                          class="btn btn-block btn-sm text-danger"
                          @click="deleteImage(vm.id)"
                        >
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </slide>
                    </carousel>
                  </div>
                  <div class="col-md-12">
   
                    <b-button
                      pill
                      block
                      size="sm"
                      variant="outline-primary mt-2"
                      id="pick-image12"
                      >{{ $t("picture") }}</b-button
                    >
                    <avatar-cropper
                      :upload-handler="cropperHandler"
                      @changed="setFileName"
                      trigger="#pick-image12"
                      :output-quality="0.8"
                      :labels="{
                        submit: $t('accept'),
                        cancel: $t('cancel'),
                      }"
                      :cropper-options="{
                        aspectRatio: 1,
                        autoCropArea: 1,
                        viewMode: 1,
                        movable: false,
                        zoomable: false,
                      }"
                    />
          
                  </div>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import imageZoom from "vue-image-zoomer";
import { Carousel, Slide } from "vue-carousel";
import AvatarCropper from "vue-avatar-cropper";
import helpers from "@/services/helpers";
import { myRendeImage } from "@/directives/render-Image";
export default {
  mixins: [myRendeImage],
  components: {
    imageZoom,
    Carousel,
    Slide,
    AvatarCropper,
  },
  async mounted() {
    await this.setProduct(this.id);
    await this.setImagesProduct(this.id);
    this.destImage = this.getProduct.picture;
  },
  data() {
    return {
      id: this.$route.params.id,
      gallery: [],
      destImage: "",
      fileSelected: null,
    };
  },
  methods: {
    ...mapActions({
      setProduct: "product/getProduct",
      setGalleryProduct: "product/galleryProduct",
      setImagesProduct: "product/getImagesProduct",
      setDeleteImage: "product/getDeleteImage",
    }),
     setFileName(file) {
      this.fileSelected = file;
    },
    async cropperHandler(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.gallery = [file];
      await this.save()
    },
    changeImage(data) {
      this.destImage = data.image;
    },
    async save() {
      let payload = {
        product_id: this.id,
        gallery: this.gallery,
      };
      const res = await this.setGalleryProduct(payload);
      this.gallery = [];
      this.$toast.success(res.message, {
        position: "top-right",
      });
    },
    async deleteImage(id) {
      const res = await this.setDeleteImage(id);
      this.$toast.success(res.message, {
        position: "top-right",
      });
    },
  },
  computed: {
    ...mapGetters({
      getProduct: "product/product",
      getImages: "product/images",
    }),
  },
};
</script>
